import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { BusinessViewPage } from '@/components/Business/BusinessViewPage'
import {
  businessViewSearchSchema,
  EMPTY_BUSINESS_SEARCH,
  withoutBusinessDefaults,
  type BusinessViewSearch,
} from '@/components/Business/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/business/view')({
  validateSearch: businessViewSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_BUSINESS_SEARCH)] },
  component: BusinessViewRoute,
})

function BusinessViewRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<BusinessViewSearch>) =>
      void navigate({
        search: (current) => withoutBusinessDefaults({ ...current, ...next }),
        replace: true,
        // The page's own change: a sort, a filter or a page keeps the reader where they are.
        resetScroll: false,
      }),
    [navigate],
  )
  return <BusinessViewPage search={search} onSearchChange={onSearchChange} />
}
